export default __webpack_public_path__ + "static/media/Create-documentation.2646f2c4.md";